import { IPatient } from "@/Common/Models/Patient/IPatient";

class GeneratedAttachmentResponse {
    public Id: string;
    public AttachmentId: string;
    public ImportedDocumentId: string;

    public constructor(fields?: Partial<GeneratedAttachmentResponse>) {
        if (fields)
            Object.assign(this, fields);
    }

    public get isImported(): boolean {
        return !!this.ImportedDocumentId;
    }

    public getDisplayName(patient: IPatient): string {
        if (!patient)
            return "";

        return `${patient.FirstName} ${patient.LastName}_${cacheStore.GetString("AttachmentLabel")}.pdf`;
    }
}

export { GeneratedAttachmentResponse };
